import "./App.css";
import Cart from "./pages/Cart";
import Footer from "./components/Footer/Footer"
import Layout from "./components/Layout/Layout";

function App() {
  return <Layout />
}

export default App;
